import { render, staticRenderFns } from "./subscriptionOrderHistory.vue?vue&type=template&id=effec9f0&"
import script from "./subscriptionOrderHistory.vue?vue&type=script&lang=js&"
export * from "./subscriptionOrderHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports